const StatusIcon = ({completed, total}) => {
  const isComplete = completed === total

  return isComplete ? (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 24 24'
      fill='#0e9f6e'
      className='icon icon-tabler icons-tabler-filled icon-tabler-circle-check'
    >
      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
      <path d='M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.293 5.953a1 1 0 0 0 -1.32 -.083l-.094 .083l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.403 1.403l.083 .094l2 2l.094 .083a1 1 0 0 0 1.226 0l.094 .083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z' />
    </svg>
  ) : (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 24 24'
      fill='none'
      stroke='#6a7282'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      className='icon icon-tabler icons-tabler-outline icon-tabler-circle-dashed'
    >
      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
      <path d='M8.56 3.69a9 9 0 0 0 -2.92 1.95' />
      <path d='M3.69 8.56a9 9 0 0 0 -.69 3.44' />
      <path d='M3.69 15.44a9 9 0 0 0 1.95 2.92' />
      <path d='M8.56 20.31a9 9 0 0 0 3.44 .69' />
      <path d='M15.44 20.31a9 9 0 0 0 2.92 -1.95' />
      <path d='M20.31 15.44a9 9 0 0 0 .69 -3.44' />
      <path d='M20.31 8.56a9 9 0 0 0 -1.95 -2.92' />
      <path d='M15.44 3.69a9 9 0 0 0 -3.44 -.69' />
    </svg>
  )
}

const StatusItem = ({status, label}) => (
  <li className='d-flex align-items-center mb-2'>
    <span className='me-2'>
      <StatusIcon completed={status.completed} total={status.total} />
    </span>
    <span className='fw-normal fs-6'>{label}</span>
    <span className='ms-auto fw-semibold'>{`${status.completed}/${status.total}`}</span>
  </li>
)
export default StatusItem
